import QueueApprovalsList from './QueueApprovalsList';
import HistoryApprovalsList from './HistoryApprovalsList';
import ApprovalsShow from './ApprovalsShow';

export const queueApprovals = {
  list: QueueApprovalsList,
  show: ApprovalsShow,
};

export const approvals = {
  show: ApprovalsShow,
};

export const historyApprovals = {
  list: HistoryApprovalsList,
  show: ApprovalsShow,
};
